<template>
  <div
    class="w-full flex"
    :class="[`md:${[width]}`, typeQuestion.name === 'check' ? 'items-start' : 'items-end']"
  >

    <template v-if="typeQuestion.name === 'text'">
      <div
        class="py-2 px-0 md:px-6 w-full"
        :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
      >
        <label
          class="font-semibold"
          for=""
        >{{question[locale]}}</label>
        <input
          class="h-12 mt-2 block border-blue-500 font-semibold text-gray-700 border w-full rounded pl-6 outline-none"
          type="text"
          :name="name"
          @input="updateTextLeft"
          maxlength="255"
          :placeholder="placeholder ? placeholder[locale] : ''"
          :data-vv-scope="vvScope"
          :data-vv-as="question[locale]"
          v-validate="validations"
          v-model="field"
          @change="changeAnswer"
        >
        <ul>
          <li
            v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
            :key="index"
            class="text-sm text-red-500 font-semibold mt-2 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
    <template v-if="typeQuestion.name === 'textarea'">
      <div
        class="py-2 px-0 md:px-6 w-full"
        :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
      >
        <label
          class="font-semibold"
          for=""
        >{{question[locale]}}</label>
        <div class="relative">
          <textarea
            class="p-4 mt-2 block border-blue-500 text-gray-700 font-semibold border w-full rounded resize-none"
            rows="8"
            cols="50"
            @input="updateTextLeft"
            :name="name"
            :placeholder="placeholder ? placeholder[locale] : ''"
            :data-vv-scope="vvScope"
            v-validate="{...validations, max_words: 500}"
            v-model="field"
            :data-vv-as="question[locale]"
            @change="changeAnswer"
            v-block
            v-on:input="watchedIds.includes(id) ? handleChange(id) : null"
            @click="modalSubscribed"
          ></textarea>
          <span
            class="counter-char text-gray-500 select-none text-xs tracking-widest absolute bottom-0 right-0 p-3 font-bold"
            :class="[{'text-blue-500': field.length > 480}]"
          >{{textLengthLeft}}/500</span>
        </div>
        <ul>
          <li
            v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
            :key="index"
            class="text-sm text-red-500 font-semibold mt-2 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
    <template v-else-if="typeQuestion.name === 'select'">
      <div
        class="py-2 px-0 md:px-6 w-full"
        :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
      >
        <label
          class="font-semibold"
          for=""
        >{{question[locale]}}</label>
        <select
          class="h-12 mt-2 block border-blue-500 font-semibold text-gray-700 border rounded w-full pl-6 bg-white  appearance-none focus:outline-none custom-select"
          name="first"
          :placeholder="placeholder ? placeholder[locale] : ''"
          :data-vv-scope="vvScope"
          :data-vv-as="question[locale]"
          v-validate="validations"
          v-model="field"
          @change="changeAnswer"
        >
          <option
            v-for="(value) in questionOption"
            :key="value.id"
            :value="value.id"
          >{{value.option[locale]}}</option>
        </select>
        <ul>
          <li
            v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
            :key="index"
            class="text-sm text-red-500 font-semibold mt-2 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
    <template v-else-if="typeQuestion.name === 'radio'">
      {{question[locale]}}
      <div
        v-for="(value) in questionOption"
        :key="value.id"
      >
        <input
          type="radio"
          :name="name"
          :id="value.id"
          :value="value.id"
          :placeholder="placeholder ? placeholder[locale] : ''"
          :data-vv-scope="vvScope"
          :data-vv-as="question[locale]"
          v-validate="validations"
          v-model="field"
          @change="changeAnswer"
        > {{value.title}}

        <ul>
          <li
            v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
            :key="index"
            class="text-sm text-red-500 font-semibold mt-2 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
    <template v-else-if="typeQuestion.name === 'checkbox'">
      <div
        class="py-2 px-0 md:px-6 flex flex-wrap"
        :class="[
          {'form-group--error': errors.first(`${vvScope}.${name}`)},
        ]"
      >
        <label
          class="font-semibold w-full py-6"
          for=""
        >{{question[locale]}}</label>
        <div
          v-for="value in questionOption"
          :key="value.id"
          class="p-2 w-1/2 text-gray-700 font-semibold flex items-center"
        >

          <input
            type="checkbox"
            class="checkbox-question mr-4"
            :name="name[locale]"
            :id="value.id"
            :value="value.id"
            :placeholder="placeholder ? placeholder[locale] : ''"
            :data-vv-scope="vvScope"
            :data-vv-as="question[locale]"
            v-validate="validations"
            v-model="field"
            @change="changeAnswer"
          > {{value.option[locale]}}
        </div>
        <ul>
          <li
            v-for="(error, index) in errors.collect(`${vvScope}.${name}`)"
            :key="index"
            class="text-sm text-red-500 font-semibold mt-2 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
    <template v-else-if="typeQuestion.name === 'multiple'">
      <div class="py-2 px-0 md:px-6 w-full">
        <label
          class="font-semibold"
          for=""
        >{{question[locale]}}</label>

        <SelectInput
          @add="addMultipleAnswer"
          @remove="removeMultipleAnswer"
          :withimages="true"
          itemkey="id"
          :multiple="true"
          :limit="10"
          imagekey="url"
          :namekey="meta === 'ideal-couple-live' ? 'name' : 'option'"
          :placeholder="placeholder ? placeholder[locale] : ''"
          vvclass="form-group--error"
          :hasLocale="meta === 'ideal-couple-live' || meta === 'Languages'"
          :sorted="meta === 'ideal-couple-live'"
          :locale="locale"
          :vvscope="vvScope"
          :vvname="name[locale]"
          :vvdata="question[locale]"
          :require="checkRequired()"
          :items="options"
          :selecteditem="selectedTags"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SelectInput from "@/components/SelectInput.vue";
import bus from "@/bus";
import _ from 'lodash';

export default {
  props: [
    "question",
    "typeQuestion",
    "questionOption",
    "placeholder",
    "validations",
    "vvScope",
    "name",
    "width",
    "id",
    "answer",
    "meta"
  ],
  components: {
    SelectInput
  },
  data: () => ({
    field: [],
    answerId: [],
    MultiselectValue: [],
    options: [],
    selectedTags: null,
    textLengthLeft: 500,
    watchedIds: [39, 40, 43, 48] // Those are questions ID's that are needed to be watched if are edited
  }),
  name: "QuestionProfile",
  computed: {
    ...mapState("answer", ["answers"]),
    ...mapState("locale", ["locale"]),
    ...mapState("countries", ["countries"])
  },
  async created() {
    if (this.meta === "ideal-couple-live") {
      await this.listCountries();
      this.options = this.countries.slice();
    } else {
      this.options = this.questionOption;
    }

    if (this.answer.length) {
      this.field = this.answer.slice()[0].value;
      if (this.typeQuestion.name === "checkbox") {
        this.field = this.answer.slice()[0].value.split(",");
      }
      if (this.typeQuestion.name === "multiple") {
        const tags = this.answer.slice()[0].value.split(",");
        if (this.meta === "ideal-couple-live") {
          const currentItems = this.countries.filter(country =>
            tags.some(tag => parseInt(tag, 10) === country.id)
          );

          const hasZone = this.countries
            .filter(country => !country.iso)
            .map(country => country.id);

          if (
            !!currentItems.find(
              item => /world/gi.test(item.name) || /mundo/gi.test(item.name)
            )
          ) {
            this.options = [];
          } else if (hasZone.length) {
            this.options = this.countries
              .slice()
              .filter(
                country =>
                  !country.iso &&
                  !/world/gi.test(country.name[this.locale]) &&
                  !/mundo/gi.test(country.name[this.locale])
              );
          } else {
            this.options = this.countries
              .slice()
              .filter(country => !!country.url);
          }
          this.selectedTags = this.countries.filter(country =>
            tags.includes(country.id.toString())
          );
        } else {
          this.selectedTags = this.options.filter(option =>
            tags.includes(option.id.toString())
          );
        }

        this.field = tags;
      }
      this.updateTextLeft();
    }
  },
  methods: {
    ...mapActions("countries", ["listCountries"]),
    checkRequired() {
      return _.get(this.validations, 'required', true);
    },
    handleChange(from=null) {
      bus.$emit('input-changed', from);
    },
    modalSubscribed() {
      if (this.$store.state.auth.user.subscription_status &&  this.$store.state.auth.user.subscription_status === 'active' )
        return;
      if (this.$store.state.auth.user.enable_edit_profile)
        return;

      this.$swal
          .fire({
            html:`<b><p style = ' color: #1c4c91;'> ${ this.$t('edit_profile_limit.message')}</p></b> <br>`,
            width: 760,
            confirmButtonText: this.$t('messages.general.subscribe'),
            allowOutsideClick: false,
            confirmButtonColor: '#1C4C91',
            background: 'center #EFF3F2 url(https://jwperfectmatch.com/storage/image/banner-profile-subscribe.webp) no-repeat'
          }).then(result =>{
              if (result.value) {
                this.$router.push('../subscriptions');
              }
            });
    },

    updateTextLeft() {
      this.textLengthLeft =
        this.field.length < 500 ? 500 - this.field.length : 0;
    },
    addMultipleAnswer(value) {
      const specialValues = this.countries
        .filter(country => !country.iso)
        .map(country => country.id);

      if (this.meta === "ideal-couple-live") {
        const {
          name: { [this.locale]: country }
        } = this.countries.find(country => country.id === value);

        if (/world/gi.test(country) || /mundo/gi.test(country)) {
          this.options = [];
        } else if (specialValues.includes(value)) {
          this.options = this.countries
            .slice()
            .filter(
              country =>
                !country.iso &&
                !/world/gi.test(country.name[this.locale]) &&
                !/mundo/gi.test(country.name[this.locale])
            );
        } else {
          this.options = this.countries
            .slice()
            .filter(country => !!country.url);
        }
      }

      this.field.push(value);
      this.changeAnswerMultiple();
    },
    removeMultipleAnswer(value) {
      if (this.meta === "ideal-couple-live") {
        if (this.field.length === 1) {
          this.options = this.countries.slice();
        }
      }

      this.field = this.field.filter(item => parseInt(item, 10) !== value);
      this.changeAnswerMultiple();
    },
    async changeAnswerMultiple(value, id) {
      this.field.forEach(element => {
        this.answerId.push(element);
      });

      let answer = this.answer.length > 0 ? this.answer[0].id : null;
      await this.saveAnswers({
        id: this.id,
        value: this.answerId.toString(),
        type: this.typeQuestion.name,
        answer_id: answer
      });
      this.answerId = [];
    },

    ...mapActions("answer", ["saveAnswers"]),
    async changeAnswer() {
      let answer = this.answer.length > 0 ? this.answer[0].id : null;
      await this.saveAnswers({
        id: this.id,
        value: Array.isArray(this.field) ? this.field.toString() : this.field,
        type: this.typeQuestion.name,
        answer_id: answer
      });
    }
  }
};
</script>

<style lang="scss" scope>
.checkbox-question {
  height: 25px;
  width: 25px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 1px solid #90cdf4;
  border-radius: 4px;
  outline: none;
  transition-duration: 0.3s;
  cursor: pointer;
  position: relative;

  &:checked {
    border: 1px solid #90cdf4;
    &::before {
      content: "";
      position: absolute;
      background-color: #90cdf4;
      border-radius: 4px;
      width: 15px;
      height: 15px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -52%);
      transition: all 0.3s ease-in-out;
    }
  }
}
</style>
